module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.33d82b7c.woff2";